<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ overskrift }}</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <div class="flex margin--top-l" *ngIf="serviceaftale.currentServiceinterval?.eftersynState">
    Eftersyn status:
    <ng-container [ngSwitch]="$safeNavigationMigration(serviceaftale.currentServiceinterval?.eftersynState?.eftersynState)">
      <div class="flex-wrap flex-wrap--flex-start flex-wrap--align-center tiny-text">
        <ng-container *ngSwitchCase="eftersynStateEnum.NotCreated">
          <mat-icon svgIcon="thumb-down" class="red"></mat-icon>
          <i class="no-line-height">Eftersyn IKKE oprettet</i>
        </ng-container>
        <ng-container *ngSwitchCase="eftersynStateEnum.Created">
          <mat-icon svgIcon="point" class="orange"></mat-icon>
          <a
            *ngIf="serviceaftale.currentServiceinterval.eftersynState.eftersyn.serviceordreNo"
            [routerLink]="['/ordre', $safeNavigationMigration(serviceaftale.currentServiceinterval.eftersynState?.eftersyn?.serviceordreNo), 'edit']"
            class="blue"
          >
            <i class="no-line-height">Eftersyn oprettet</i>
          </a>
        </ng-container>
        <ng-container *ngSwitchCase="eftersynStateEnum.Completed">
          <mat-icon svgIcon="thumb-up" class="green"></mat-icon>
          <a
            *ngIf="serviceaftale.currentServiceinterval.eftersynState.eftersyn.serviceordreNo"
            [routerLink]="['/ordre', serviceaftale.currentServiceinterval.eftersynState.eftersyn.serviceordreNo, 'edit']"
            class="blue"
          >
            <i class="no-line-height">Eftersyn gennemført</i>
          </a>
        </ng-container>
        <ng-container *ngSwitchDefault></ng-container>
      </div>
    </ng-container>
  </div>
  <div class="form-row">
    <mat-radio-group [(ngModel)]="validFrom">
      <mat-radio-button [disabled]="!allowInstantChange" [value]="today">Omgående</mat-radio-button>
      <mat-radio-button
        *ngIf="!serviceaftale.serviceAbonnement.isTilkaldsabonnement"
        [value]="nextServiceintervalStartDate"
        [disabled]="!nextServiceintervalStartDate"
      >
        Først fra næste serviceinterval
        <br />
        <small *ngIf="nextServiceintervalStartDate" class="absolute">
          Næste periode starter d. {{ nextServiceintervalStartDate | date: 'dd.MM.yyyy' }}
        </small>
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
<div mat-dialog-actions class="align-center">
  <button mat-raised-button (click)="submit()" color="primary" [disabled]="!validFrom" matTooltip="">{{ buttonTekst }}</button>
</div>
